import localization from 'utils/localization'
import projectsAssets from "assets/projects"

const PROJECTS = [
    {
        image: projectsAssets.metalpass,
        title: 'MetalPass',
        tools: 'Firebase | Gatsby | Material-UI | MercadoPago | React | Redux',
        link: 'https://metalpass.com.br',
        description: localization('project-metalpass')
    },
    {
        image: projectsAssets.dashMetalpass[0],
        title: 'MetalPass Dashboard',
        tools: 'Firebase | Material-UI | React | Redux',
        slideshow: projectsAssets.dashMetalpass,
        description: localization('project-metalpass-dash')
    },
    {
        image: projectsAssets.chaoticTracker[0],
        title: 'Chaotic Tracker',
        tools: 'Paper | React Native | Redux',
        slideshow: projectsAssets.chaoticTracker,
        description: localization('project-chaotic-tracker')
    },
    {
        image: projectsAssets.ox3Web[0],
        title: 'OX3 Dashboard',
        tools: 'Firebase | Google Maps | Material-UI | React | Recharts | Redux',
        slideshow: projectsAssets.ox3Web,
        description: localization('project-ox3-dash')
    },
    {
        image: projectsAssets.ox3App[0],
        title: 'OX3 Mobile',
        tools: 'Firebase | Google Maps | Paper | React-Native | Redux',
        slideshow: projectsAssets.ox3App,
        description: localization('project-ox3-mobile')
    },
    {
        image: projectsAssets.easyHouse[0],
        title: 'Easy House SOS',
        tools: 'Firebase | Google Maps | Material-UI | React | Redux',
        slideshow: projectsAssets.easyHouse,
        description: localization('project-easy-house')
    },
    {
        image: projectsAssets.edupop[0],
        title: 'EduPOP',
        tools: 'Firebase | Paper | React Native | Redux',
        slideshow: projectsAssets.edupop,
        description: localization('project-edupop')
    },
    {
        image: projectsAssets.gabi[0],
        title: 'GABI',
        tools: 'Algolia | Firebase | Google Maps | Material-UI | React | Redux',
        slideshow: projectsAssets.gabi,
        description: localization('project-gabi')
    },
    {
        image: projectsAssets.visity[0],
        title: 'Visity',
        tools: 'Algolia | Firebase | Google Maps | Material-UI | React Native | Redux | SQLite',
        slideshow: projectsAssets.visity,
        description: localization('project-visity')
    },
    {
        image: projectsAssets.fnc,
        title: 'Foco no Cooperativismo',
        tools: 'Firebase | Gatsby | Material-UI | React | Redux',
        link: 'https://foconocooperativismo.com.br/',
        description: localization('project-fnc')
    },
]

export default PROJECTS